import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';

import { glossary } from '#src/lib/glossary.ts';
import { useIsCurrentCardSet } from '#src/set/index.ts';

import type { CardSetLabel_cardSet } from './__generated__/index.graphql.ts';

type Props = {
  cardSet: Nullable<CardSetLabel_cardSet>;
};

const ACTIVE_SET_STYLE: React.CSSProperties = {
  background:
    'linear-gradient(315deg, var(--c-set-surface-primary) 14.64%, #e8ecee 85.36%)',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  color: 'transparent',
};

export const CardSetLabel = ({ cardSet }: Props) => {
  const isCurrentCardSet = useIsCurrentCardSet();

  if (!cardSet) {
    return null;
  }

  return (
    <span style={isCurrentCardSet(cardSet.slug) ? ACTIVE_SET_STYLE : {}}>
      <FormattedMessage
        {...glossary.setEdition}
        values={{
          set: cardSet.name,
        }}
      />
    </span>
  );
};

CardSetLabel.fragments = {
  cardSet: gql`
    fragment CardSetLabel_cardSet on CardSet {
      slug
      name
    }
  ` as TypedDocumentNode<CardSetLabel_cardSet>,
};
